const state = {
    namespaced: true,
    state: {
        title: process.env.VUE_APP_PRODUCT_TITLE,
        version: '2',
        client: 'Jikatel',
        isLoading: true,
        isDrawerOpen: true,
        productName: process.env.VUE_APP_PRODUCT_NAME,
        generalDialogStatus: false,
        generalDialogTitle: "Message",
        generalDialogMessage: "",
    },
    actions: {
        downloadFile(ctx, {url, fileName}) {
            const link = document.createElement('a');
            link.style.display = 'none';
            link.href = url
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        doneLoading(ctx, params ) {
            ctx.commit('DONE_LOADING');
        },
        setState ({ commit }, params) {
            commit('SET_STATE', params)
        },
    },
    mutations: {
        DONE_LOADING(state) {
            state.isLoading = false;
        },
        SET_STATE (state, params) {
            state[params.key] = params.value
        },
    }
}

export default state
